export const validateOrcidFormat = (
  orcid: string
): { isValid: boolean; message: string } => {
  const trimmed = orcid.trim();
  const orcidRegex = /^\d{4}-\d{4}-\d{4}-\d{3}[0-9X]$/;

  if (!trimmed) {
    return { isValid: false, message: 'ORCID cannot be empty' };
  }

  if (!orcidRegex.test(trimmed)) {
    return {
      isValid: false,
      message: 'Please enter a valid ORCID (0000-0001-2345-6789)'
    };
  }

  return { isValid: true, message: '' };
};
